<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>备案号: <a href="http://www.beian.miit.gov.cn/" rel="nofollow" target="_blank">苏ICP备16011924号-2</a> Copyright © 2020 南京记工智能软件中心 版权所有</p>
  </div>
</template>

<script>
export default {
  name: 'WebIndex',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
